/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Drawer, Dialog, makeStyles, Button } from "@material-ui/core";
import CompanyIconDefault from "assets/svgs/CompanyIconDefault";
import CrossIcon from "assets/svgs/CrossIcon";
import { ToastContext } from "context/Toast/ToastContext";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { getUserId } from "utils";
import { postExternalJobAppliedFeedback } from "utils/apiClientPrivate";
import { getUrlPath } from "utils/helpers";
import { useWindowResize } from "utils/hooks";
import Image from "next/image";
import RoundedCloseIcon from "assets/svgs/RoundedCloseIcon";
import { setJobAsAppliedInLS } from "utils/commonUtils";
import { LOCAL_STORAGE_KEYS } from "utils/constants";
import { useRouter } from "next/router";

const useStyles = makeStyles({
	dialog: {
		height: 336,
		maxWidth: 688,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "8px",
	},
	button: {
		color: "#1F8268",
		border: "1px solid #1F8268",
		padding: "12px",
	},
	drawer: {
		overflow: "visible",
		borderTopLeftRadius: "16px",
		borderTopRightRadius: "16px",
		padding: "16px",
	},
});

const ExternalJobAppliedFeedbackModal = ({
	job,
	isOpen,
	handleClose,
	commonTrackingObj,
	markExternalJobAsApplied,
	moduleTrackData,
}) => {
	const [isMobileView] = useWindowResize();
	const classes = useStyles();
	const { handleOpenToast } = useContext(ToastContext);
	const router = useRouter();

	const handleFeedbackInput = async (value) => {
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Did you apply for Job", {
				...commonTrackingObj,
				page: getUrlPath(),
				action: value,
			});
		});
		const dataObject = {
			job: job?.id,
			status: value === "yes" ? "application_sent" : "viewed",
			user: getUserId(),
			source: "WEB_APNACO",
		};
		try {
			await postExternalJobAppliedFeedback(dataObject);
			if (value === "yes") {
				import("utils/Mixpanel").then((Mixpanel) => {
					Mixpanel.default.track("Web Job Application Successful", {
						page: getUrlPath(),
						"Job ID": job.id,
						JobTitle: job?.title,
						area: job?.address?.area,
						city: job?.address?.city?.name,
						maxSalary: job?.max_salary ? job?.max_salary : "N/A",
						minSalary: job?.min_salary ? job?.min_salary : "N/A",
						"Job Board Type": "Non Apna Job",
						earning_potential: job?.earning_potential
							? job?.earning_potential
							: "N/A",
						is_wfh: job?.is_wfh ? job?.is_wfh : "N/A",
						Job_company_name: job?.organization?.name,
						"External Job Type": job?.is_external_job
							? job?.job_lead_type
							: "",
						"Search ID": router?.query?.search
							? localStorage.getItem(LOCAL_STORAGE_KEYS.SEARCH_SESSION_ID)
							: "",
						...moduleTrackData,
					});
				});
				setJobAsAppliedInLS(job?.id);
				markExternalJobAsApplied();
			}
			if (value !== "crossIcon") {
				handleOpenToast({
					heading: "Thank you for the feedback",
					type: "success",
				});
			}
		} catch (e) {
			console.log(e);
			handleOpenToast({
				heading: "Something went wrong. Try again!",
				type: "error",
			});
		}
		handleClose();
	};

	if (isMobileView) {
		return (
			<Drawer
				open={isOpen}
				anchor="bottom"
				classes={{
					paper: classes.drawer,
				}}
			>
				<div onClick={handleClose} className="absolute right-[16px] top-[-44px]">
					<RoundedCloseIcon />
				</div>
				<HeadingContainer>
					<p>Did you apply?</p>
				</HeadingContainer>
				<SubTextContainer>
					<p>Your feedback will help us improve job recommendations for you</p>
				</SubTextContainer>
				<CompanyDetailsContainer>
					{job?.organization?.logo_url ? (
						<ImageContainer>
							<ImageComponent
								src={job?.organization?.logo_url}
								alt="company-logo"
							/>
						</ImageContainer>
					) : (
						<CompanyIconDefault />
					)}
					<InfoContainer>
						<PositionLabel>{job?.title}</PositionLabel>
						<CompanyLabel>{job?.organization?.name}</CompanyLabel>
					</InfoContainer>
				</CompanyDetailsContainer>
				<ButtonsContainer>
					<Button
						variant="outlined"
						fullWidth
						classes={{
							root: classes.button,
						}}
						onClick={() => handleFeedbackInput("yes")}
					>
						<ButtonText>Yes</ButtonText>
					</Button>
					<Button
						variant="outlined"
						fullWidth
						classes={{
							root: classes.button,
						}}
						onClick={() => handleFeedbackInput("no")}
					>
						<ButtonText>No</ButtonText>
					</Button>
				</ButtonsContainer>
			</Drawer>
		);
	}
	return (
		<Dialog
			open={isOpen}
			classes={{
				paper: classes.dialog,
			}}
		>
			<div className="h-[240px] w-[688px]">
				<CrossIcon
					className="absolute right-[16px] top-[16px] cursor-pointer"
					onClick={() => handleFeedbackInput("crossIcon")}
				/>
				<div className="mx-auto flex w-[440px] flex-col items-center pt-[40px]">
					<p className="m-0 p-0 text-[20px] font-bold leading-[28px]">
						Did you apply?
					</p>
					<p className="m-0 mt-[4px] p-0 text-center text-[16px] font-normal leading-[24px] text-[#8C8594]">
						Your feedback will help us improve job recommendations for you
					</p>
				</div>
				<div className="mx-auto my-[24px] flex h-[72px] w-[440px] items-center rounded-[8px] bg-[#F4F2F6] p-[16px]">
					{job?.organization?.logo_url ? (
						<div className="h-[40px] w-[40px]">
							<Image
								src={job?.organization?.logo_url}
								alt="company-logo"
								height={40}
								width={40}
							/>
						</div>
					) : (
						<CompanyIconDefault />
					)}
					<div className="ml-[12px] flex-1">
						<div className="text-left text-[14px] font-normal leading-[20px]">
							{job?.title}
						</div>
						<div className="text-left text-[14px] font-normal leading-[20px] text-[#8C8594]">
							{job?.organization?.name}
						</div>
					</div>
				</div>
			</div>
			<div className="border-top flex h-[96px] w-full items-center justify-center border-[1px] border-solid border-[#DFE1E6]">
				<button
					className="mr-[16px] h-[48px] w-[212px] rounded-[4px] border-[1px] border-[#1F8268] px-[32px] py-[12px] text-[16px] font-semibold leading-[24px] text-[#1F8268]"
					onClick={() => handleFeedbackInput("yes")}
					type="button"
				>
					Yes
				</button>
				<button
					className="p-[12px 32px 12px 32px] h-[48px] w-[212px] rounded-[4px] border-[1px] border-[#1F8268] text-[16px] font-semibold leading-[24px] text-[#1F8268]"
					onClick={() => handleFeedbackInput("no")}
					type="button"
				>
					No
				</button>
			</div>
		</Dialog>
	);
};

export default ExternalJobAppliedFeedbackModal;

const HeadingContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;

	color: #190a28;
	font-size: 20px;
	font-weight: 700;
	line-height: 28px;
	margin-bottom: 8px;

	p {
		margin: 0;
	}
	svg {
		cursor: pointer;
	}
`;
const SubTextContainer = styled.div`
	width: 328px;
	color: #827485;
	font-size: 14px;
	line-height: 20px;
	margin-bottom: 24px;
	p {
		margin: 0;
	}
`;
const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;
const ButtonText = styled.p`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
`;
const CompanyDetailsContainer = styled.div`
	padding: 16px;
	display: flex;
	align-items: center;
	margin-bottom: 32px;

	border-radius: 8px;
	background: #f4f2f6;
	gap: 12px;
`;
const ImageContainer = styled.div`
	position: relative;
	width: 32px;
	height: 32px;
`;

const ImageComponent = styled.img`
	position: relative;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;
const InfoContainer = styled.div``;
const PositionLabel = styled.p`
	margin: 0;

	color: #190a28;
	font-size: 14px;
	line-height: 20px;
`;
const CompanyLabel = styled.p`
	color: #8c8594;
	line-height: 20px;
	font-size: 14px;
	margin: 0;
`;
